import { Country } from '../../domain/country';
import { UserSegment, UserSegmentType } from '../../domain/user-segment';
import { CountryViewModel, PageEditUserSegment } from '../../page-edit-screen/components/page-edit-screen/page-edit-screen.view-model';

export const mapUserSegmentsToViewModel = (userSegments: UserSegment[]): PageEditUserSegment[] => {
  return userSegments.reduce((prev: PageEditUserSegment[], curr: UserSegment) => {
    switch (curr.name) {
      case UserSegmentType.Anonymous:
        return prev.concat({ id: curr.id, label: 'Anonymous', originalName: curr.name });
      case UserSegmentType.Prospect:
        return prev.concat({ id: curr.id, label: 'Prospect', originalName: curr.name });
      case UserSegmentType.Normal:
        return prev.concat({ id: curr.id, label: 'Normal', originalName: curr.name });
      case UserSegmentType.PendingChurn:
        return prev.concat({ id: curr.id, label: 'Pending-churn', originalName: curr.name });
      case UserSegmentType.Dunning:
        return prev.concat({ id: curr.id, label: 'Dunning', originalName: curr.name });
      case UserSegmentType.Churned:
        return prev.concat({ id: curr.id, label: 'Churned', originalName: curr.name });
      default:
        return prev;
    }
  }, []);
};

export const mapCountriesToViewModel = (countries: Country[]): CountryViewModel[] => {
  return countries.map((country: Country) => {
    return {
      id: country.id,
      label: country.name,
      iso2Code: country.iso2Code,
    };
  });
};
